import { Chapters } from './Chapters'
import { withChapters } from './withChapters'

const Connected = withChapters(Chapters)

export { Connected as Chapters }
